/**
 * @param {Function} callback
 * @returns {import('react').KeyboardEventHandler<HTMLElement>}
 */
const onKeyDownSpace = callback => (/** @type {import('react').KeyboardEvent<HTMLElement>} */ e) => {
  if (e.key === ' ') {
    e.preventDefault();
  }
  callback(e);
};

export default onKeyDownSpace;
